import React from 'react';
import { Typography, Box } from '@mui/material';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { useTranslation } from 'react-i18next';
import { formatDate, LOCALE_MAP } from 'utils/locale-formatting';
import { TransparencyPageHeader } from '../styles';

/**
 * TransparencyHeader - Company identity header for public transparency page
 * @param {string} name - Company name
 * @param {string} description - Company description
 * @param {string} lastUpdated - Last update date
 * @param {string} brandingLogoUrl - Optional custom branding logo URL
 */
export const TransparencyHeader = ({ name, description, lastUpdated, brandingLogoUrl }) => {
  const { t, i18n } = useTranslation('transparency');
  const locale = LOCALE_MAP[i18n.language] ?? 'en-US';
  return (
    <TransparencyPageHeader>
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
        {brandingLogoUrl
          ? <img src={brandingLogoUrl} alt={`${name} logo`} style={{ maxHeight: 64, maxWidth: 200, objectFit: 'contain' }} />
          : <VerifiedUserIcon sx={{ fontSize: 48, opacity: 0.9 }} />
        }
      </Box>
      <Typography variant="h4" fontWeight={700} gutterBottom>
        {name}
      </Typography>
      {description && (
        <Typography variant="body1" sx={{ opacity: 0.9, maxWidth: 600, mx: 'auto', mb: 2 }}>
          {description}
        </Typography>
      )}
      <Typography variant="caption" sx={{ opacity: 0.7 }}>
        {t('shared.transparencyCenter')}
        {lastUpdated && ` | ${t('shared.lastUpdated', { date: formatDate(lastUpdated, locale) })}`}
      </Typography>
    </TransparencyPageHeader>
  );
};
